export default function SettingsNavigation({ children }) {
  return <div className="settings-navigation"><h1 className="settings-list-heading text-xl font-semibold">Settings</h1>{children}</div>;
}
